import moment from "moment";

import {
  IFlyerDetailPagePosition,
  IFlyerDetailPagePositionCopy,
} from "../../../../../../types/flyer-detail-data/flyer-detail-page-position/flyer-detail-page-position.interface";

import { PositionCategory } from "../../features/flyer-detail-page-form-position/types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.interface";

import {
  FlyerDetailPagePositionCopyResponse,
  FlyerDetailPagePositionResponse,
} from "./flyer-detail-page-position-response.interface";
import { FlyerDetailPagePositionForm } from "../../features/flyer-detail-page-form-position/types/flyer-detail-page-position-form.interface";

export function mapFlyerDetailPagePositionResponseToIFlyerDetailPagePosition(
  response: FlyerDetailPagePositionResponse
): IFlyerDetailPagePosition {
  return {
    id: response.id,
    label: response.name,
    badge: response.badge,
    categories: response.categories || [],
    categoryDetails: response.categoryDetails || [],
    merchOwners: response.merchOwners,
    dealEndDate: response.endAt ? moment(response.endAt).format("YYYY-MM-DD") : "",
    dealStartDate: response.startAt ? moment(response.startAt).format("YYYY-MM-DD") : "",
    copies: response.copies.map(
      mapFlyerDetailPagePositionCopyResponseToIFlyerDetailPagePositionCopy
    ),
    products: response.products,
  };
}

export function mapFlyerDetailPagePositionCopyResponseToIFlyerDetailPagePositionCopy(
  response: FlyerDetailPagePositionCopyResponse
): IFlyerDetailPagePositionCopy {
  return {
    id: response.id,
    copyCard: response.copyCard || "",
    getCopyCard: response.getCopyCard || "",
    productImage: response.productImage || "",
    getProductImage: response.getProductImage || "",
    brandLogo: response.brandLogo || "",
    language: response.language,
  };
}

export function mapFlyerDetailPagePositionFormToRequest(
  changes: Partial<FlyerDetailPagePositionForm>
) {
  return {
    ...changes,
    categories: changes.categories?.map((category: PositionCategory) => category.id) || [],
  };
}
